import React, { Component } from "react";
import { connect } from "react-redux";

// Absolute media URLs are already ready for the browser. Relative media URLs
// must stay relative so production resolves them against the current store
// origin instead of a developer machine.
export const resolveCountryFlagUrl = (flag) =>
  typeof flag === "string" ? flag.trim() : "";

class ScrollerItem extends Component {
  render() {
    const { themeColor, isSelected, flag, id } = this.props;
    return (
      <div
        style={{
          marginRight: 8,
          marginLeft: 8,
          justifySelf: "center",
          userSelect: "none",
          cursor: "pointer",
          opacity: isSelected ? 1 : 0.6,
          width: 80,
          height: 70,
          border: isSelected ? `2px solid ${themeColor}` : "1px solid #cecece",
          borderRadius: 4,
          display: "grid",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => {
          this.props.setSelectedCountry(id);
        }}
      >
        {!!flag && (
          <img
            src={resolveCountryFlagUrl(flag)}
            alt=""
            style={{
              width: 24 * 1.3,
              height: 24 * 1.3,

              pointerEvents: "none",
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollerItem);
